import React, { useState } from 'react';
import uniqBy from 'lodash.uniqby';
import { GenericItem } from '@marty-js/api-sdk/types';
import { useInfiniteScroll } from '../utils/infinite-scroll.hooks';

type InfiniteScrollElementProps = {
  genericItem: GenericItem;
  index?: number;
};

export type InfiniteScrollGenericItemComponent = React.ComponentType<InfiniteScrollElementProps>;
type InfiniteScrollProps = {
  genericItems: GenericItem[];
  loading: Boolean;
  GenericItemComponent: InfiniteScrollGenericItemComponent;
  total: number;
  LoadElement: React.ComponentType;
  fetchMore: (from: number) => void;
};

const Loading = ({ LoadElement, total, genericItems }: Partial<InfiniteScrollProps>) => {
  return (
    <>
      {Array.from({ length: total - genericItems.length > 10 ? 10 : total - genericItems.length }).map((_, index) => (
        <LoadElement key={index} />
      ))}
    </>
  );
};

const InfiniteScroll = ({
  genericItems,
  GenericItemComponent,
  loading,
  fetchMore,
  total,
  LoadElement,
}: InfiniteScrollProps) => {
  const [curLength, setCurLenght] = useState(0);

  const detectorRef = useInfiniteScroll(() => {
    setCurLenght(genericItems.length);
    fetchMore(genericItems.length);
  });

  return (
    <>
      {loading && !genericItems.length ? (
        <Loading LoadElement={LoadElement} total={total} genericItems={genericItems} />
      ) : (
        uniqBy(genericItems, 'id')?.map((item: GenericItem, index: number) => (
          <GenericItemComponent key={item.id} index={index} genericItem={item} />
        ))
      )}
      {total <= genericItems.length ? null : (
        <>
          <div ref={detectorRef} aria-hidden />
          {curLength === genericItems.length ? (
            <Loading LoadElement={LoadElement} total={total} genericItems={genericItems} />
          ) : null}
        </>
      )}
    </>
  );
};

export default InfiniteScroll;
